module.exports = __webpack_public_path__ + "static/img/home.44f34a7d.png";